import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EMPTY, Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Entity} from './main.entity';
import {AppService} from 'app/services/app.service';
import {environment} from '../../environments/environment';
import {ApiResponse} from 'app/entities/apiResponse.entity';
import HttpClientUtils from './httpClientUtils';
import {serialize} from 'object-to-formdata';

@Injectable()
export abstract class MainModelService {

  public baseUrl = environment.baseUrl;
  public url: string | undefined;
  public data: Entity | undefined;

  protected apiUrl = environment.apiUrl;

  protected model: string | undefined;
  protected http: HttpClient;

  protected appService: AppService;

  constructor(
    http: HttpClient,
    appService: AppService
  ) {
    this.http = http;
    this.appService = appService;
  }

  async getRequest(
    getData: any,
    callback: (answer: any) => void,
    url: string | null = null,
    loading: boolean = true,
    message: boolean | string  = false
  ) {
    this.serverRequest(url, 'GET', {}, getData, {}, callback, loading, message);
  }

  async jsonRequest(
    getData: any,
    callback: (answer: any) => void,
    url: string | null = null,
    loading: boolean = true
  ) {
    this.serverRequest(url, 'JSON', {}, getData, {}, callback, loading);
  }

  async putRequest(
    postData: any,
    getData: any,
    callback: (answer: any) => void,
    url: string | null = null,
    loading: boolean = true
  ) {
    this.serverRequest(url, 'PUT', postData, getData, {}, callback, loading);
  }

  async deleteRequest(
    postData: any,
    getData: any,
    callback: (answer: ApiResponse) => void,
    url: string | null = null,
    loading: boolean = true
  ) {
    this.serverRequest(url, 'DELETE', postData, getData, {}, callback, loading);
  }

  async postRequest(
    postData: any,
    getData: any,
    callback: (answer: ApiResponse) => void,
    url: string | null = null,
    loading: boolean = true
  ) {
    this.serverRequest(url, 'POST', postData, getData, {}, callback, loading);
  }

  public async testRequest(callback: any, loading = false, timer = 500) {
    await this.showLoading(loading);

    setTimeout(() => {
      this.hideLoading(loading);
      callback();
    }, timer);
  }

  public getUrl(url: string | null = null): string {
    if (url && (url.includes('http://') || url.includes('https://'))) {
      return url;
    }
    return this.baseUrl + this.apiUrl + (this.model ? this.model : '') + (url ? '/' + url : '');
  }

  protected async serverRequest(
    url: string,
    method: string = 'GET',
    postData: any,
    getData: any = [],
    headers: any = null,
    callback: (response: any) => void,
    loading: boolean = true,
    message: boolean | string = false
  ) {
    url = this.getUrl(url);

    if (loading) {
      await this.showLoading(loading);
    }

    // headers = {
    //   'sec-fetch-dest': 'empty',
    //   'sec-fetch-mode': 'no-cors',
    //   'sec-fetch-site': 'sec-fetch-site'
    // };

    const params = this.getParams(getData);

    const options: any = {
      params,
      headers,
      // mode: 'no-cors',
      withCredentials: false,
      observe: 'response'
    };

    let request = of(null);

    let skipSerialize = false;
    if (Array.isArray(postData)) {
      skipSerialize = !!(arr => arr.every(i => typeof i === 'string' || typeof i === 'number'));
    }

    if (!skipSerialize) {
      postData = serialize(postData, {indices: true, nullsAsUndefineds: false, allowEmptyArrays: true}) as FormData;
    }

    if (method === 'GET') {
      request = this.http.get<any>(url, options);
    } else if (method === 'JSON') {
      request = this.http.jsonp<any>(url + '?' + params.toString(), getData.callback);
    } else if (method === 'DELETE') {
      options.body = postData;
      request = this.http.delete<any>(url, options);
    } else if (method === 'POST') {
      request = this.http.post<any>(url, postData, options);
    } else if (method === 'PUT') {
      request = this.http.put<any>(url, postData, options);
    }

    request
      .pipe(
        catchError((error: any, caught): any => {
          this.hideLoading(loading);

          console.log(error);
          console.log(error.status === 500 || error.status === 0 || error.status === 504);

          if (error.status === 500 || error.status === 0 || error.status === 504) {

            if (error.status === 0 || error.status === 504) {
              this.appService.offline = true;
            } else {
              return this.handleDeepError(error);
            }

          } else {
            this.handleError(error, callback, message);
            return EMPTY;
          }

        })
      )
      .subscribe((res: any) => {

        this.hideLoading(loading);

        if ((typeof res.body !== 'undefined') || (typeof res.result !== 'undefined')) {
          this.handleSuccess(res, callback);
        }

        if (res.body?.status === false) {
          this.handleError(res.body, callback, message);
        }

      }, error => {
        this.handleError(error, callback, message);
      });

  }

  protected async handleError(data: ApiResponse, callback: (answer: ApiResponse) => void, message: boolean | string = false) {
    callback(data);
  }

  protected async handleSuccess(data: ApiResponse, callback: (answer: ApiResponse) => void) {
    callback(data);
  }

  protected async handleDeepError(error: any) {

    console.log('handleDeepError');

    this.showAlert('Error', error.message, true);
    return throwError(error.message);
  }

  private showAlert(title: string | null = null, desc: string | null = null, error = false) {
    this.appService.showAlert(title, desc, error);
  }

  private abortFileTransfer() {

  }

  private getParams(array: any) {
    return HttpClientUtils.toHttpParams(array);
  }

  private async showLoading(loading: boolean) {
    if (loading) {
      await this.appService.showLoading();
    }
  }

  private async hideLoading(loading: boolean) {
    if (loading) {
      await this.appService.hideLoading();
    }
  }

}
